export default [
  {
    title: '服务类型',
    dataIndex: 'billingServiceType',
    key: 'billingServiceType',
    scopedSlots: { customRender: 'billingServiceType' }
  },
  {
    title: '变更类型',
    dataIndex: 'changeType',
    key: 'changeType',
    scopedSlots: { customRender: 'changeType' }
  },
  {
    title: '变更前',
    dataIndex: 'beforeChangeValue',
    key: 'beforeChangeValue',
  },
  {
    title: '变更内容',
    dataIndex: 'changeValue',
    key: 'changeValue',
  },
  {
    title: '变更后',
    dataIndex: 'afterChangeValue',
    key: 'afterChangeValue',
  },
  {
    title: '备注',
    dataIndex: 'notes',
    key: 'notes',
  },
  {
    title: '使用描述',
    dataIndex: 'useDescription',
    key: 'useDescription',
    scopedSlots: { customRender: 'useDescription' }
  },
  {
    title: '创建时间',
    dataIndex: 'createdAt',
    key: 'createdAt'
  }
]
